import { useToast } from "vue-toastification";
import { getDeviceInfo } from "@/helpers/helper";
import { getSession, clearSession } from "@/stores/session";
import axios from "axios";
import router from "@/router";
import { isMaintenance, markUpdating } from "@/stores/maintenance";

const toast = useToast();

let toastShown = false;

/*
 * The API lives under this same address at /api, so every call is to the
 * page's own address: the sign-in cookie goes with it on its own, and the
 * address tells the API which company this is. No token or company header is
 * added here any more.
 */
const http = () => {
  const apiClient = axios.create({
    baseURL: "/api/v1/",
    validateStatus: (status) => status >= 200 && status < 300,
  });

  apiClient.interceptors.request.use((config) => {
    config.headers["X-Device-Info"] = JSON.stringify(getDeviceInfo());
    return config;
  });

  apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
      // A deploy in progress: say so once, across the whole screen, rather
      // than letting every call on the page fail with its own error.
      if (isMaintenance(error)) {
        markUpdating();
      }

      const signedIn = getSession().signedIn;
      if (error.response && error.response.status === 401 && signedIn) {
        clearSession();
        if (!toastShown) {
          // Signed out to set up Google Authenticator says so; anything else is an expired session.
          const twoFactor = error.response.data?.errors?.code === "TWO_FACTOR_SETUP_REQUIRED";
          toast.error(twoFactor ? error.response.data.message : "Your session has expired. Please log in again.");
          toastShown = true;
          setTimeout(() => {
            toastShown = false;
          }, 5000);
        }
        router.push({ name: "auth.sign-in" });
      }
      return Promise.reject(error);
    },
  );
  return apiClient;
};

export default http;
